import RestApiModel from "@/api/Model/RestApiModel";
import Sections from '@/api/Facility/Sections';
import Markets from '@/api/Facility/Markets';
import DistributionList from '@/api/Facility/DistributionList';
import FDO from '@/api/Facility/FDO';
import Underwriter from '@/api/Facility/Underwriter';
import api from '../index';

class Facility extends RestApiModel {
  static sections = Sections;
  static markets = Markets;
  static fdos = FDO;
  static distributionLists = DistributionList;
  static underwriters = Underwriter;

  static getResourceEndpoint() {
    return '/facilities';
  }

  /**
   * @returns {Promise<AxiosResponse<any>>}
   */
  static counts() {
    return this.list({endpoint: this.getResourceEndpoint() + '/counts'});
  }

  /**
   * @param id
   * @param isPublished
   * @returns {*}
   */
  static publish(id, isPublished) {
    return api.patch(`${this.getResourceIdEndpoint(id)}/publish`, {isPublished});
  }

  /**
   * @param id
   * @param isEnabled
   * @returns {*}
   */
  static enable(id, isEnabled) {
    return api.patch(`${this.getResourceIdEndpoint(id)}/enable`, {isEnabled});
  }
}

export default Facility;
